import {TariffCountKey, TariffFlagKey} from 'entities/tariff';

export interface ICountChip {
    key: TariffCountKey,
    prefix?: string,
    suffix?: string,
}

export interface IFlagChip {
    key: TariffFlagKey,
    label: string,
}

export type TariffLimitChip = ICountChip | IFlagChip;

export const isFlagChip = (chip: TariffLimitChip): chip is IFlagChip => 'label' in chip;

export const MONITORING_LIMITS: TariffLimitChip[] = [
    {key: 'monitor_max_count_limit', suffix: ' сайт.'},
    {key: 'server_max_count_limit', suffix: ' серв.'},
    {key: 'domain_monitor_max_count_limit', suffix: ' дом.'},
    {key: 'port_monitor_max_count_limit', suffix: ' порт.'},
    {key: 'location_max_count_limit', suffix: ' лок.'},
    {key: 'monitor_min_check_interval_limit', prefix: 'от ', suffix: ' мин'},
    {key: 'server_alert_rules_max_count_limit', suffix: ' прав. увед.'},
];

export const STATUS_PAGE_LIMITS: TariffLimitChip[] = [
    {key: 'status_pages_max_count_limit', suffix: ' стр. статуса'},
    {key: 'status_page_hide_banner_enabled', label: 'без баннера'},
];

export const REPORT_LIMITS: TariffLimitChip[] = [
    {key: 'reports_max_count_limit', suffix: ' отчётов'},
    {key: 'report_hide_banner_enabled', label: 'без баннера'},
];

export const NOTIFICATION_LIMITS: TariffLimitChip[] = [
    {key: 'telegram_chats_max_count_limit', prefix: 'TG '},
    {key: 'max_chats_max_count_limit', prefix: 'MAX '},
    {key: 'webhook_max_count_limit', prefix: 'WH '},
    {key: 'additional_emails_max_count_limit', prefix: 'Email '},
];
